module.exports = __webpack_public_path__ + "images/emoji/green_book.9616b706092632a793c0.png";